import { render } from "./Specialists.vue?vue&type=template&id=5f934ae2&scoped=true"
import script from "./Specialists.vue?vue&type=script&lang=js"
export * from "./Specialists.vue?vue&type=script&lang=js"

import "./Specialists.vue?vue&type=style&index=0&id=5f934ae2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f934ae2"]])

export default __exports__